<template>
  <GenericStep v-bind="$attrs">
    <div
      v-for="immigration_proceeding of peParty.immigration_proceedings"
      :key="immigration_proceeding.id"
      class="mb-12"
    >
      <ImmigrationProceedingsCard
        :item="immigration_proceeding"
      />
    </div>

    <SectionAdderLine
      section="Immigration Proceeding"
      :has-new-section="peImmigrationProceedingsCardHasNewSection"
      @on-add="peImmigrationProceedingsCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import ImmigrationProceedingsCard from '@/components/Party/PartyEdit/SectionCards/BackgroundCards/ImmigrationProceedingsCard.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'

export default {
  name: 'ImmigrationProceedingsStep',

  components: {
    GenericStep,
    ImmigrationProceedingsCard,
    SectionAdderLine,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return this.peParty.immigration_proceedings
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peImmigrationProceedingsCardHasNewSection',
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peImmigrationProceedingsCardAddSection',
    ]),
  },
}
</script>
